import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Navigation from './components/Navigation';
import BackToTop from './components/BackToTop';
import WhatsAppButton from './components/WhatsAppButton';
import Landing from './pages/Landing';
import CategoryPage from './pages/CategoryPage';
import Shop from './pages/Shop';
import ShopCategory from './pages/ShopCategory';
import ShopProduct from './pages/ShopProduct';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Auth from './pages/Auth';
import Account from './pages/Account';
import AdminDashboard from './pages/AdminDashboard';
import Gallery from './pages/Gallery';
import GalleryCategory from './pages/GalleryCategory';
import Projects from './pages/Projects';
import { Toaster } from './components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  const updateCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem('cart', JSON.stringify(newCart));
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-[#050505]">
        <Navigation user={user} logout={logout} cartCount={cart.length} />
        <BackToTop />
        <WhatsAppButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/category/:categoryId" element={<ShopCategory />} />
          <Route path="/shop/product/:productId" element={<ShopProduct cart={cart} updateCart={updateCart} />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:categoryId" element={<GalleryCategory />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/product/:id" element={<ProductDetail cart={cart} updateCart={updateCart} />} />
          <Route path="/cart" element={<Cart cart={cart} updateCart={updateCart} />} />
          <Route path="/checkout" element={<Checkout cart={cart} updateCart={updateCart} user={user} />} />
          <Route path="/auth" element={<Auth setUser={setUser} />} />
          <Route path="/account" element={user ? <Account user={user} /> : <Navigate to="/auth" />} />
          <Route path="/admin" element={user?.role === 'admin' ? <AdminDashboard /> : <Navigate to="/" />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;